import { Col, Divider, Row, Tag, Tooltip, Typography } from 'antd'
import React, { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import ExperienceForm from './experience-form'
import { EditIcon, NoExperienceIcon } from '../../../assets/icons'
import NoIndividualContent from '../../profile/tabSection/noIndividualContent'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import FileUploadModal from './fileUploadModal'
import AttachmentPreview from '../../../components/attachmentPreview/attachmentPreview'

const ExperienceList = ({
    currantData,
    activeTab,
    candidateId,
    showForm,
    setShowForm,
    status
}) => {
    const { Title, Text } = Typography
    const [editData, setEditData] = useState(null)
    const [currantAttachments, setCurrantAttachments] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const { isLoading } = useSelector((state) => state.candidateSlice)
    const convertToUserStatus = 'convertToUser'
    return (
        <div>
            <div style={{ marginTop: '15px' }}>
                {!showForm && !isLoading && (
                    <dib>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Title level={4}>Experience</Title>
                            {
                                status !==
                                convertToUserStatus &&
                                <Tooltip title="Add Experience">
                                    <button
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginLeft: '10px',
                                            borderRadius: '50%',
                                            border: 'none',
                                        }}
                                        onClick={() => {
                                            setShowForm(true)
                                            setEditData(null)
                                        }}
                                    >
                                        <PlusOutlined
                                            style={{ fontSize: '15px' }}
                                        />
                                    </button>
                                </Tooltip>
                            }

                        </div>
                        {currantData?.experience?.length === 0 ? (
                            <NoIndividualContent
                                content={{
                                    key: 'experience',
                                    title: 'Experience',
                                    icon: <NoExperienceIcon />,
                                }}
                            />
                        ) : (
                            <div style={{ marginTop: '15px' }}>
                                {currantData?.experience?.map((e) => {
                                    return (
                                        <Row gutter={25} key={e._id}>
                                            <Col
                                                xs={4}
                                                sm={4}
                                                md={4}
                                                lg={4}
                                                xl={4}
                                                style={{
                                                    border: '1px solid #f0f0f0 ',
                                                    padding: '10px',
                                                    height: '100%',
                                                    borderRadius: '8px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <div className="educationSvgLogo" />
                                            </Col>
                                            <Col
                                                xs={20}
                                                sm={20}
                                                md={20}
                                                lg={20}
                                                xl={20}
                                            >
                                                <div>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        <Title level={5}>
                                                            {e?.title}
                                                        </Title>
                                                        {
                                                            status !==
                                                            convertToUserStatus &&
                                                            <Tooltip title="Edit Experience">
                                                                <button
                                                                    style={{
                                                                        width: '26px',
                                                                        height: '26px',
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                        justifyContent:
                                                                            'center',
                                                                        marginLeft:
                                                                            '5px',
                                                                        borderRadius:
                                                                            '50%',
                                                                        border: 'none',
                                                                        backgroundColor:
                                                                            'transparent',
                                                                    }}
                                                                    onClick={() => {
                                                                        setShowForm(
                                                                            true
                                                                        )
                                                                        setEditData(
                                                                            e
                                                                        )
                                                                    }}
                                                                >
                                                                    <EditIcon />
                                                                    {/* <PlusOutlined style={{ fontSize: '15px' }} /> */}
                                                                </button>
                                                            </Tooltip>
                                                        }

                                                    </div>

                                                    <div
                                                        style={{
                                                            marginTop: '5px',
                                                        }}
                                                    >
                                                        {e?.company?.name && (
                                                            <>
                                                                <Text
                                                                    style={{
                                                                        fontSize:
                                                                            '14px',
                                                                        marginRight:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    {
                                                                        e
                                                                            ?.company
                                                                            ?.name
                                                                    }
                                                                </Text>
                                                                {e?.location && (
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                '14px',
                                                                            marginRight:
                                                                                '10px',
                                                                        }}
                                                                    >
                                                                        |
                                                                    </Text>
                                                                )}
                                                            </>
                                                        )}

                                                        {e?.location && (
                                                            <>
                                                                <Text
                                                                    style={{
                                                                        fontSize:
                                                                            '14px',
                                                                        marginRight:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    {
                                                                        e?.location
                                                                    }
                                                                </Text>
                                                            </>
                                                        )}
                                                    </div>

                                                </div>

                                                {e?.startDate != null && (
                                                    <div
                                                        style={{
                                                            marginTop: '5px',
                                                        }}
                                                    >
                                                        <Text
                                                            style={{
                                                                color: '#b9b9b9',
                                                                fontSize:
                                                                    '16px',
                                                            }}
                                                        >
                                                            <Text
                                                                style={{
                                                                    color: '#b9b9b9',
                                                                    fontSize:
                                                                        '16px',
                                                                }}
                                                            >
                                                                {dayjs(
                                                                    e?.startDate
                                                                ).format(
                                                                    'DD MMM YY'
                                                                )}
                                                            </Text>
                                                        </Text>
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    '14px',
                                                                marginRight:
                                                                    '10px',
                                                                marginLeft:
                                                                    '10px',
                                                            }}
                                                        >
                                                            -
                                                        </Text>
                                                        <Text
                                                            style={{
                                                                color: '#b9b9b9',
                                                                fontSize:
                                                                    '16px',
                                                            }}
                                                        >
                                                            {!e.currentlyWorking && (
                                                                <Text
                                                                    style={{
                                                                        color: '#b9b9b9',
                                                                        fontSize:
                                                                            '16px',
                                                                    }}
                                                                >
                                                                    {dayjs(
                                                                        e?.endDate
                                                                    ).format(
                                                                        'DD MMM YY'
                                                                    )}
                                                                </Text>
                                                            )}
                                                            {e.currentlyWorking && (
                                                                <Text
                                                                    style={{
                                                                        color: '#b9b9b9',
                                                                        fontSize:
                                                                            '16px',
                                                                    }}
                                                                >
                                                                    Present
                                                                </Text>
                                                            )}
                                                        </Text>
                                                    </div>
                                                )}
                                                {e?.summary && (
                                                    <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                        <Text
                                                            style={{
                                                                fontSize:
                                                                    '14px',
                                                            }}
                                                        >
                                                            {e.summary}
                                                        </Text>
                                                    </div>
                                                )}
                                                <div>
                                                    {e?.skills?.length > 0 && (
                                                        <>
                                                            <div
                                                                style={{
                                                                    marginTop:
                                                                        '15px',
                                                                }}
                                                            >
                                                                <div>
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                '18px',
                                                                        }}
                                                                    >
                                                                        Skills
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                            <Row gutter={10}>
                                                                {e?.skills?.map(
                                                                    (
                                                                        skill,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <Tag
                                                                                key={
                                                                                    index
                                                                                }
                                                                                bordered={
                                                                                    false
                                                                                }
                                                                                color="processing"
                                                                                style={{
                                                                                    marginTop:
                                                                                        '10px',
                                                                                    cursor: 'auto',
                                                                                }}
                                                                            >
                                                                                {
                                                                                    skill?.name
                                                                                }
                                                                            </Tag>
                                                                        )
                                                                    }
                                                                )}
                                                            </Row>
                                                        </>
                                                    )}
                                                </div>
                                                <div>
                                                    {e?.programmingLanguages
                                                        ?.length > 0 && (
                                                            <>
                                                                <div
                                                                    style={{
                                                                        marginTop:
                                                                            '15px',
                                                                    }}
                                                                >
                                                                    <div>
                                                                        <Text
                                                                            style={{
                                                                                fontSize:
                                                                                    '18px',
                                                                            }}
                                                                        >
                                                                            Programming
                                                                            Languages
                                                                        </Text>
                                                                    </div>
                                                                </div>
                                                                <Row gutter={10}>
                                                                    {e?.programmingLanguages?.map(
                                                                        (
                                                                            data,
                                                                            index
                                                                        ) => {
                                                                            return (
                                                                                <Tag
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                    bordered={
                                                                                        false
                                                                                    }
                                                                                    color="processing"
                                                                                    style={{
                                                                                        marginTop:
                                                                                            '10px',
                                                                                        cursor: 'auto',
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        data?.name
                                                                                    }
                                                                                </Tag>
                                                                            )
                                                                        }
                                                                    )}
                                                                </Row>
                                                            </>
                                                        )}
                                                </div>
                                                <div>
                                                    {e?.tools?.length > 0 && (
                                                        <>
                                                            <div
                                                                style={{
                                                                    marginTop:
                                                                        '15px',
                                                                }}
                                                            >
                                                                <div>
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                '18px',
                                                                        }}
                                                                    >
                                                                        Tools
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                            <Row gutter={10}>
                                                                {e?.tools?.map(
                                                                    (
                                                                        data,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <Tag
                                                                                key={
                                                                                    index
                                                                                }
                                                                                bordered={
                                                                                    false
                                                                                }
                                                                                color="processing"
                                                                                style={{
                                                                                    marginTop:
                                                                                        '10px',
                                                                                    cursor: 'auto',
                                                                                }}
                                                                            >
                                                                                {
                                                                                    data?.name
                                                                                }
                                                                            </Tag>
                                                                        )
                                                                    }
                                                                )}
                                                            </Row>
                                                        </>
                                                    )}
                                                </div>
                                                <div>
                                                    {e?.technicalSkills
                                                        ?.length > 0 && (
                                                            <>
                                                                <div
                                                                    style={{
                                                                        marginTop:
                                                                            '15px',
                                                                    }}
                                                                >
                                                                    <div>
                                                                        <Text
                                                                            style={{
                                                                                fontSize:
                                                                                    '18px',
                                                                            }}
                                                                        >
                                                                            Technical
                                                                            Skills
                                                                        </Text>
                                                                    </div>
                                                                </div>
                                                                <Row gutter={10}>
                                                                    {e?.technicalSkills?.map(
                                                                        (
                                                                            data,
                                                                            index
                                                                        ) => {
                                                                            return (
                                                                                <Tag
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                    bordered={
                                                                                        false
                                                                                    }
                                                                                    color="processing"
                                                                                    style={{
                                                                                        marginTop:
                                                                                            '10px',
                                                                                        cursor: 'auto',
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        data?.name
                                                                                    }
                                                                                </Tag>
                                                                            )
                                                                        }
                                                                    )}
                                                                </Row>
                                                            </>
                                                        )}
                                                </div>
                                            </Col>
                                            <Divider />
                                        </Row>
                                    )
                                })}
                                <div>
                                    <FileUploadModal
                                        isModalOpen={isModalOpen}
                                        setIsModalOpen={setIsModalOpen}
                                        show={status !== convertToUserStatus}
                                        activeTab="EXPERIENCE"
                                        category="Experience"
                                        preAttachmentList={
                                            currantData?.attachments
                                        }
                                        setCurrantAttachments={
                                            setCurrantAttachments
                                        }
                                        currentData={currantAttachments}
                                    />
                                    <div
                                        style={{
                                            marginTop: 15,
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '8px',
                                        }}
                                    >
                                        {currantData?.attachments?.length > 0 ? currantData?.attachments?.map(
                                            (fileObj, i) => (
                                                <AttachmentPreview
                                                    key={fileObj._id || i}
                                                    file={fileObj}
                                                    displayName={
                                                        fileObj.displayName
                                                    }
                                                    showRemove={true}
                                                    onEdit={(f) => {
                                                        setIsModalOpen(true)
                                                        setCurrantAttachments(f)
                                                    }}
                                                    status={status}
                                                />
                                            )
                                        ) : <div>

                                            <Text style={{ color: "#6c656570", fontSize: "16px" }}>No Attachment</Text>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        )}
                    </dib>
                )}
                {showForm && (
                    <ExperienceForm
                        onCancel={setShowForm}
                        candidateId={candidateId}
                        currantData={editData}
                        activeTab={activeTab}
                        preExperinceData={currantData}
                    />
                )}
            </div>
        </div>
    )
}

export default ExperienceList
